export enum CaseTypeType {
	FOLDER = 'folder',
	CASE_TYPE = 'caseType',
}
